import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Pagination } from 'antd';
import { DevicesTabContext, IDevicesTabContext } from '../../devicesTabState/devicesTabContext';
import style from './DevicesPagination.module.scss';

const DevicesPagination: React.FC = () => {
	const { changeDevicesTabCurrentPage, restaurantDevices, devicesTabCurrentPage, devicesTabCountOfItems } =
		useContext<IDevicesTabContext>(DevicesTabContext);

	const from = (devicesTabCurrentPage - 1) * Number(devicesTabCountOfItems) + 1;
	const to = devicesTabCurrentPage * Number(devicesTabCountOfItems);
	const total = restaurantDevices.count;

	return (
		<div className={style.container} data-test="DevicesPagination">
			<Text
				className={style.counter}
				translationNameSpace="form"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={devicesTabCurrentPage}
				pageSize={Number(devicesTabCountOfItems)}
				total={restaurantDevices.count}
				onChange={changeDevicesTabCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug}></div>
		</div>
	);
};

export default DevicesPagination;
